export type UserPermission = string[];
export interface AuthParams {
  requiredPermissions?: string[];
  oneOfPerm?: boolean;
}

// 无限遍历，拿到children的权限
const getChildrenPermission = (permissions: any[]) => {
  const result: string[] = [];
  for (const permission of permissions) {
    result.push(permission.path || permission.title);
    if (permission.children) {
      result.push(...getChildrenPermission(permission.children));
    }
  }
  return result;
};

export default (params: AuthParams, userPermission: UserPermission) => {
  const { requiredPermissions, oneOfPerm } = params;
  const userPermissionKeys = getChildrenPermission(userPermission || []);
  if (Array.isArray(requiredPermissions) && requiredPermissions.length) {
    let count = 0;
    for (const rp of requiredPermissions) {
      if (userPermissionKeys.includes(rp)) {
        count++;
      }
    }
    return oneOfPerm ? count > 0 : count === requiredPermissions.length;
  }
  return true;
};
